import { useSuspenseQuery } from '@tanstack/react-query';
import { queryKey } from 'mypage/src/constant/queryKey';
import {
  productCategoryService
} from 'shared/src/api';

export const useProductCategories = () => {
  return useSuspenseQuery({
    queryKey: queryKey.productCategories(),
    queryFn: () => productCategoryService.getProductCategories(),
    select: data => data.product_category_groups,
  });
};
